// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-connections-modal-title {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 1.5rem;
}

.connection-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 20px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.connection-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.connection-info-box p {
  margin: 0;
}

.connection-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.connections-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.connection-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.connection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.connection-platform-name {
  font-size: 1.4rem;
  font-weight: 600;
  color: #5616ea;
  margin: 0;
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
  line-height: 1;
}

.connection-platform-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  line-height: 1;
}

.connection-display-name {
  font-size: 0.9rem;
  color: #999;
  margin-top: 4px;
}

.unassigned-badge {
  display: inline-block;
  align-self: flex-start;
  background-color: #fff9e1;
  color: #554002;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  border-left: 4px solid #ffc107;
}

.expired-badge {
  display: inline-block;
  background-color: #fdecea;
  color: #611a15;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 10px;
  border-left: 4px solid #e53935;
}

.expired-reconnect-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background-color: #fdecea;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 0.88rem;
  color: #611a15;
  border-left: 4px solid #e53935;
  line-height: 1.4;
}

.expired-reconnect-bar .expired-icon {
  color: #e53935;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.connection-delete-btn {
  padding: 8px;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.2s ease, color 0.2s ease;
  text-align: center;
  background-color: transparent;
  color: #6b6b6b;
}

.connection-delete-btn:hover {
  transform: scale(1.1);
}

.connection-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.connection-info-row p {
  margin: 0;
}

.connection-info-row strong {
  color: #333;
}

.connection-editable {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.connection-mode-help {
  font-size: 0.82rem;
  color: #666;
  line-height: 1.35;
  margin-top: -4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.connection-editor-footer {
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid #eeecf3;
  background: #fff;
}
.connection-editor-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.connection-delete-btn:disabled { opacity: 0.45; cursor: default; }

.modal-save-btn {
  min-width: 100px;
  padding: 10px 24px;
  background-color: #5616ea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.modal-save-btn:hover:not(:disabled) {
  background-color: #4a14d6;
}

.modal-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-close-btn {
  padding: 10px 24px;
  background-color: transparent;
  color: #5616ea;
  border: 2px solid #5616ea;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.modal-close-btn:hover {
  background-color: #f3eaff;
  border-color: #5e0fb3;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.empty-state p {
  margin: 0;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .manage-connections-modal-title {
    font-size: 1.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ManageConnectionsModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA,kCAAkC,aAAa,EAAE,eAAe,EAAE;;AAElE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".manage-connections-modal-title {\r\n  margin-top: 0;\r\n  margin-bottom: 20px;\r\n  color: #333;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.connection-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.connection-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.connection-info-box p {\r\n  margin: 0;\r\n}\r\n\r\n.connection-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.connections-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.connection-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 10px;\r\n  background: #ffffff;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.connection-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.connection-platform-name {\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  min-width: 0;\r\n  line-height: 1;\r\n}\r\n\r\n.connection-platform-name-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n  line-height: 1;\r\n}\r\n\r\n.connection-display-name {\r\n  font-size: 0.9rem;\r\n  color: #999;\r\n  margin-top: 4px;\r\n}\r\n\r\n.unassigned-badge {\r\n  display: inline-block;\r\n  align-self: flex-start;\r\n  background-color: #fff9e1;\r\n  color: #554002;\r\n  padding: 4px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  border-left: 4px solid #ffc107;\r\n}\r\n\r\n.expired-badge {\r\n  display: inline-block;\r\n  background-color: #fdecea;\r\n  color: #611a15;\r\n  padding: 4px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  margin-top: 10px;\r\n  border-left: 4px solid #e53935;\r\n}\r\n\r\n.expired-reconnect-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  background-color: #fdecea;\r\n  border-radius: 10px;\r\n  padding: 8px 12px;\r\n  font-size: 0.88rem;\r\n  color: #611a15;\r\n  border-left: 4px solid #e53935;\r\n  line-height: 1.4;\r\n}\r\n\r\n.expired-reconnect-bar .expired-icon {\r\n  color: #e53935;\r\n  font-size: 1.1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.connection-delete-btn {\r\n  padding: 8px;\r\n  font-size: 18px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n  text-align: center;\r\n  background-color: transparent;\r\n  color: #6b6b6b;\r\n}\r\n\r\n.connection-delete-btn:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.connection-info-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.connection-info-row p {\r\n  margin: 0;\r\n}\r\n\r\n.connection-info-row strong {\r\n  color: #333;\r\n}\r\n\r\n.connection-editable {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.connection-mode-help {\r\n  font-size: 0.82rem;\r\n  color: #666;\r\n  line-height: 1.35;\r\n  margin-top: -4px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.connection-editor-footer {\r\n  flex-shrink: 0;\r\n  padding: 14px 20px;\r\n  border-top: 1px solid #eeecf3;\r\n  background: #fff;\r\n}\r\n.connection-editor-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n.connection-delete-btn:disabled { opacity: 0.45; cursor: default; }\r\n\r\n.modal-save-btn {\r\n  min-width: 100px;\r\n  padding: 10px 24px;\r\n  background-color: #5616ea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.modal-save-btn:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n.modal-save-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-close-btn {\r\n  padding: 10px 24px;\r\n  background-color: transparent;\r\n  color: #5616ea;\r\n  border: 2px solid #5616ea;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.modal-close-btn:hover {\r\n  background-color: #f3eaff;\r\n  border-color: #5e0fb3;\r\n}\r\n\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  color: #666;\r\n}\r\n\r\n.empty-state p {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .manage-connections-modal-title {\r\n    font-size: 1.4rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
